const TipoNotificacao = {
    COMISSAO: 0,
    CARREGAMENTO: 1,
    AGENDAMENTO: 2
};

export default TipoNotificacao;